import React from "react";

import { useCurrentProjectContext } from "@editor/contexts/CurrentProjectContext";

import DebugPanel from "@/features/react-editor/components/navbar/DebugPanel";
import ResponsiveControls from "@/features/react-editor/components/navbar/ResponsiveControls";
import IconButton from "@replo/design-system/components/button/IconButton";
import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

function PreviewNavbar() {
  const { project } = useCurrentProjectContext();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const funnelId = params.funnelId;
  const searchParams = new URLSearchParams(location.search);
  const menuType = searchParams.get("menu-type");

  const getHeaderTitle = () => {
    if (!funnelId) {
      return "Create New Funnel";
    }

    if (menuType === "existing") {
      return "Add Existing Page";
    }

    return "Create New Page";
  };

  const handleBackNavigation = React.useCallback(() => {
    if (!project) {
      navigate("/shops");
      return;
    }

    if (funnelId) {
      navigate(`/shops/${project.id}/funnels/${funnelId}`);
      return;
    }

    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate(`/shops/${project.id}/site`);
  }, [navigate, project, funnelId]);

  return (
    <>
      <div className="flex gap-3 w-full">
        <div className="w-1/3">
          <div className="flex flex-row items-center gap-3">
            <IconButton
              variant="secondary"
              size="base"
              onClick={handleBackNavigation}
              icon={<ArrowLeft className="text-muted" size={16} />}
            />
            <div className="header-h3">{getHeaderTitle()}</div>
          </div>
        </div>

        <div className="w-2/3 flex items-center gap-3">
          <ResponsiveControls />
          <DebugPanel />
        </div>
      </div>
    </>
  );
}

export default PreviewNavbar;
